import * as api from "../Services/api.js";

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  async getSessionsBeforeFADReport({}, data) {
    return await api
      .post("/sessionReports/getSessionsBeforeFADReport", data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return false;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
